<template>
  <div class="author">
    <user-photo :user="user" class="user-photo" :redirect-to-profil="userActive" />
    <div class="author-description">
      <div v-if="topSlot">
        {{ topSlot }}
      </div>
      <h3 data-cy="owner-name" class="author-name" @click="goTo()" :class="{clickable: userActive}">
        {{ user.firstName + ' ' + user.lastName }}
      </h3>
      <h4 class="author-job">
        {{ user.jobTitle }}
      </h4>
      <div v-if="bottomSlot">
        {{ bottomSlot }}
      </div>
    </div>
  </div>
</template>

<script>

import UserPhoto from '../shared/UserPhoto'

export default {
  name: 'UserVignette',
  components: { UserPhoto },
  props: {
    user: {
      type: Object,
      required: true
    },
    enableLink: {
      type: Boolean,
      default: true
    },
    topSlot: {
      type: String,
      default: null
    },
    bottomSlot: {
      type: String,
      default: null
    }
  },
  methods: {
    goTo() {
      if (this.userActive) {
        this.$router.push({ name: 'userInfo', params: { id: this.user.id } })
      }
    }
  },
  computed: {
    userActive() {
      return this.enableLink && this.user.anonymizedAt == null
    }
  }
}
</script>

<style scoped lang="scss">

.author {
  display: flex;
  margin: 0.5rem 0 0 1rem;
  align-items: center;

  .user-photo {
    height: 2.5rem;
    border-radius: 100%;
  }

  .author-description {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin: 0 0.7rem;

    font-size: 13px;
    line-height: 19px;

    .author-name {
      font-size: 14px;
      line-height: 21px;
      font-weight: bold;
    }

    .author-job {
      font-size: 13px;
      line-height: 19px;
      font-weight: normal;
    }
  }
}

.clickable {
  cursor: pointer;
}

</style>
